import { createSelector, MemoizedSelector } from '@ngrx/store';
import { SearchState, StateWithSearch } from '../search-state';
import { getCustomSearchState } from './feature.selector';

type ActiveFacetsState = SearchState['activeFacets'];

export const getActiveFacetsState: MemoizedSelector<StateWithSearch, ActiveFacetsState> = createSelector(
  getCustomSearchState,
  (state: SearchState) => {
    return state.activeFacets || [];
  },
);
